import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Desktop from "./components/Desktop";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Desktop />} />
        <Route path="/homework/:id" element={<Desktop />} />
      </Routes>
    </Router>
  );
}

export default App;
